import { axiosEduServer } from "../utils/configAxios";

export const crearHorario = (data) => {
  return axiosEduServer.post('/horario', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarHorario = (id, data) => {
  return axiosEduServer.put(`/horario/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarHorario = (id) => {
  return axiosEduServer.delete(`/horario/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneHorario = (id) => {
  return axiosEduServer.get(`/horario/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllHorarios = () => {
  return axiosEduServer.get('/horario').then(({ data }) => data).catch((err) => { throw err });
};